import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMoreVertical } from "react-icons/fi";
import CardHeaderTop from "../shared/CardHeaderTop";
import CardLoader from "../shared/CardLoader";
import useCardTitleActions from "../../hooks/useCardTitleActions";
import { formatDateOnly } from "../../utils/options";
const LatestLeads = ({ leads, permission }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");

  const {
    refreshKey,
    isRemoved,
    isExpanded,
    handleRefresh,
    handleExpand,
    handleDelete,
  } = useCardTitleActions();

  const getStatusColor = (status) => {
    switch ((status || "").toLowerCase()) {
      case "pending":
        return "warning";
      case "approved":
        return "success";
      case "rejected":
        return "danger";
      case "on hold":
        return "secondary";
      default:
        return "info";
    }
  };

  if (permission?.pf_view !== 1) {
    return null;
  }
  // ✅ Ensure leads is always an array
  const safeLeads = Array.isArray(leads) ? leads : [];
  const badgeColor = "warning";
  if (isRemoved) return null;

  return (
    <div className="col-xxl-8">
      <div
        className={`card stretch stretch-full ${
          isExpanded ? "card-expand" : ""
        } ${refreshKey ? "card-loading" : ""}`}
      >
        <div className="card-header-d px-4 d-flex justify-content-between align-items-center">
          <h5 className="mb-0 fw-bold">Top 6 Latest Inquiry</h5>
          <CardHeaderTop
            refresh={handleRefresh}
            remove={handleDelete}
            expanded={handleExpand}
          />
        </div>

        <div className="card-body custom-card-action p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead>
                <tr className="border-b">
                  <th>User</th>
                  <th>Amount</th>
                  <th>Inquiry Type</th>
                  <th>Date</th>
                  <th className="text-end">Status</th>
                  <th>Assigned by</th>
                  <th>Created by</th>
                </tr>
              </thead>
              <tbody>
                {safeLeads.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No inquiry found.
                    </td>
                  </tr>
                ) : (
                  safeLeads.map((val, index) => (
                    <tr key={index}>
                      <td className="position-relative">
                        <div className="d-flex align-items-center gap-3">
                          <div>
                           <div
                          className={`ht-50 position-absolute start-0 top-50 translate-middle rounded border-start border-5 border-${badgeColor}`}
                        ></div>
                            <span className="d-block fw-semibold text-capitalize">
                              {val.customer_name || ""}
                            </span>
                            <span className="d-block fs-12 text-muted">
                              {val.phone_number || ""}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="badge bg-gray-200 text-dark">
                          {val.loan_amount || ""}
                        </span>
                      </td>
                      <td>{val.loan_type_name || ""}</td>
                      <td>
                        {val.inquiry_date
                          ? formatDateOnly(new Date(val.inquiry_date))
                          : ""}
                      </td>
                      <td className="text-end">
                        <span
                          className={`badge bg-soft-${getStatusColor(
                            val.loan_inquiry_status
                          )} text-${getStatusColor(val.loan_inquiry_status)}`}
                        >
                          {val.loan_inquiry_status || ""}
                        </span>
                      </td>
                      <td>
                        <div>
                          <span className="d-block fw-semibold text-capitalize">
                            {val.assigned_name || ""}
                          </span>
                          <span className="d-block fs-12 text-muted">
                            {val.assigned_user_number || ""}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div className="bg-primary p-1 rounded">
                          <span className="d-block fw-semibold text-white text-capitalize">
                            {val.created_name || ""}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <CardLoader refreshKey={refreshKey} />
      </div>
    </div>
  );
};

export default LatestLeads;
